import { cn } from '@/lib/utils';

const Quote = ({
    variant = 'default',
    color = 'black',
    isHtml = false,
    className,
    ...props
}: React.HTMLAttributes<HTMLHeadingElement> & {
    variant?: 'default' | 'link' | 'italic';
    color?: 'black' | 'inherit';
    isHtml?: boolean;
}) => {
    const variantClasses = {
        default:
            'lg:text-[40px] text-[24px] 2xl:text-[52px] abc inline-block leading-[120%]',
        link: 'lg:text-[40px] text-[24px] 2xl:text-[52px] abc-italic leading-[120%] inline-block underline hover:no-underline',
        italic: 'lg:text-[40px] text-[24px] 2xl:text-[52px] abc-italic leading-[120%] inline-block ',
    };

    const colorClasses = {
        black: 'text-black',
        inherit: 'text-inherit',
    };

    return (
        <span
            className={cn(
                variantClasses[variant],
                colorClasses[color],
                className,
            )}
            {...(isHtml
                ? {
                      dangerouslySetInnerHTML: {
                          __html: props.children as string,
                      },
                  }
                : {})}
            {...(!isHtml ? props : {})}
        />
    );
};

Quote.displayName = 'Quote';

export default Quote;
